<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h1 class="form-header">Contacto Para Proveedor</h1>
              <div class="form-desc">
                Adición de un contacto para proveedor <span>({{proveedor.codigo}}) {{proveedor.nombre}}</span>
              </div>
              <div class="tab-content element-box" id="nav-tabContent">
                <div class="tab-pane fade show active" id="add-contacto-home" role="tabpanel"
                  aria-labelledby="nav-home-tab">
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label for>Correo*</label>
                        <input id="correo_field" v-model="current.correo" class="form-control" placeholder="ejemplo@ejemplo.com" type="text" />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono 1*</label>
                        <input v-model="current.telefono1" class="form-control" placeholder="Teléfono 1" type="text" />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono 2</label>
                        <input v-model="current.telefono2" class="form-control" placeholder="Teléfono 2" type="text" />
                      </div>
                      <div class="form-group">
                        <label for>Extensión</label>
                        <input v-model="current.extension" class="form-control" placeholder="Extensión"
                          type="text" />
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-2">
                      <div class="form-group">
                        <label for>Representante*</label>
                        <input v-model="current.nombre" class="form-control" placeholder="John Doe"
                          type="text" />
                      </div>
                      <div class="form-group">
                        <label for="categoria">Categoría de Contacto*</label>
                        <select class="form-control" v-model="current.categoria_contacto" id="categoria">
                          <option v-for="categoria in categorias.results" :key="categoria.id" :value="categoria">
                            {{ categoria.nombre }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for>Observaciones</label>
                        <textarea v-model="current.observaciones" class="form-control" placeholder="Observaciones" style="resize: none;"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" v-model="current.activo"
                            type="checkbox"/>¿Activo?
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" v-model="current.recibe_correo"
                            type="checkbox"/>¿Recibe correo?
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" v-model="current.cc_oculto" name="cc_oculto" type="checkbox"
                          />¿Recibir con copia oculta?
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- OPERATIVOS -->
                  <h6 class="p-3">Etiquetas Operativas</h6>
                  <div class="row">
                    <div
                      class="col-sm-2"
                      v-for="operativo in operativos.results"
                      :key="operativo.id"
                    >
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            @change="actualizar()"
                            class="form-check-input"
                            type="checkbox"
                            v-model="operativos_seleccionados"
                            :value="operativo.id"
                          />{{operativo.nombre}}
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- FIN OPERATIVOS -->
                  <div class="form-buttons-w">
                    <button class="btn btn-primary" @click="validar()">
                      Guardar
                    </button>
                    <router-link
                      class="btn btn-default"
                      :to="{ name: 'cat-proveedores-editar', params: {id:proveedor.codigo}}"
                    >
                        <i class="fa fa-back"></i>
                      Volver al Proveedor
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from "lodash";
  import ContactoProveedorService from "@/services/catalogos/ContactoProveedorService";
  import Notifications from "@/notifications/notifications";
  import ProveedorService from "@/services/catalogos/ProveedorService";

  export default {
    components: {
      ContactoProveedorService
    },
    data() {
      return {
        proveedor: {
          id:0
        },
        current: {
          id:null,
          proveedor: "",
          nombre: "",
          correo: "",
          telefono1: "",
          telefono2: "",
          extension: "",
          categoria_contacto: {},
          observaciones: "",
          recibe_correo: true,
          activo: true,
          cc_oculto: false,
          tags_operativos_ids: []
        },
        operativos_seleccionados:[],
        operativos_asignados:[],
        categorias:[],
        operativos:[]
      };
    },
    mounted() {
      this.refreshProveedor()
      this.setCategorias()
      this.setOperativos()
      this.refreshCurrent()
    },

    methods: {
      actualizar(){
        this.current.tags_operativos_ids = this.operativos_seleccionados
      },
      validar() {
        let self = this;
        const contacto = _.cloneDeep(this.current)
        if (contacto.id === null) {
          delete contacto.id;
        }
        if (contacto.correo.trim() === ""){
          delete contacto.correo
        }
        contacto.proveedor = this.proveedor.codigo;
        contacto.categoria_contacto = contacto.categoria_contacto.id;

        if(this.$route.params.id){
          self.guardar(contacto);
          return;
        }

        if(contacto.correo){
          let params = {correo: contacto.correo}
          ContactoProveedorService.getByCorreo(params)
          .then(response => {
            const existe = response.data.existe
            if(existe){
              Notifications.alert.confirm(
                "El correo que ingresa ya existe con otro contacto",
                "¿Esta seguro que desea guardarlo?",
                "Si",
                function () {
                  self.guardar(contacto);
                }
              );
            }
            else{
              self.guardar(contacto);
            }
          })
        }else{
          self.guardar(contacto);
        }
      },
      guardar(contacto) {
        ContactoProveedorService.asignar(contacto)
          .then(response => {
            const data = response.data

            const detail = data.detail ? data.detail: "¡Guardado con éxito!";
            const id = data.id
            if (response.status === 200 || response.status === 201){
              Notifications.alert.success(
                "Asignar Contacto a Proveedor",
                detail
              );
              this.$router.push({
                name: "cat-contacto-proveedor-editar",
                params: { id: id },
              });
            }
        }).catch(error => {
          const data = error.response.data;
          const detail = data.detail ? data.detail: "¡Ha ocurrido un error!";
          
          Notifications.alert.error(
            "Asignar Contacto a Proveedor",
            detail
          );
        });
      },
      refreshCurrent(){
        let correo_field = document.getElementById("correo_field");
        if(this.$route.params.current){
          this.current = _.cloneDeep(this.$route.params.current);
          this.proveedor = this.current.proveedor;
          ContactoProveedorService.getAction(this.current.id,"ver_tags_asignados")
          .then(response => {
            this.operativos_asignados = response.data;
            this.operativos_seleccionados = this.operativos_asignados.tags_asignados;
        })
        }else if (this.$route.params.id && !this.$route.params.current){
          ContactoProveedorService.getById(this.$route.params.id)
          .then(response=>{
            this.current = response.data;
            this.proveedor = this.current.proveedor_obj;
            this.current.categoria_contacto = this.current.categoria_contacto_obj
            ContactoProveedorService.getAction(this.current.id,"ver_tags_asignados")
            .then(response => {
              this.operativos_asignados = response.data;
              this.operativos_seleccionados = this.operativos_asignados.tags_asignados;
            })
          })
          .catch(error => {
             this.$toast.warning("Ocurrió problemas al obtener el contacto "+this.$route.params.id+", "+error.response.data.detail,"Aviso",{position: 'topRight'});
             console.error(error.response.data.detail);
           });
        }
      },
      refreshProveedor(){
        if(this.$route.params.id){return;}
        if(!this.$route.params.proveedor && !this.$route.params.id_proveedor){return;}
        if(!this.$route.params.proveedor){
          ProveedorService.getById(this.$route.params.id_proveedor)
          .then(response =>{
            this.proveedor = response.data;
          })
          .catch(error => {
            this.$toast.warning("Ocurrió problemas al obtener el proveedor "+this.$route.params.id_proveedor,"Aviso",{position: 'topRight'});
            console.error(error.response.data.detail);
          });
        }else{
          this.proveedor = _.cloneDeep(this.$route.params.proveedor);
        }
      },
      setCategorias(){
        ContactoProveedorService.getCategorias()
        .then(response=>{
          this.categorias = response.data;
        })
      },
      setOperativos(){
        let params = {
          "tipo__nombre": "RECEPCION"}
        ContactoProveedorService.getOperativos(params)
        .then(response => {
          this.operativos = response.data;
        })
      },
    },
  };
</script>